export const imagesDetails = [
  {
    alt: "Thai Church members on Christmas",
    header: "Thai Church DC",
    description: "คริสตจักรไทยดีซี",
  },
  {
    alt: "Worship Jesus",
    header: "Sunday Service: 11:30 am (ET)",
    description: "3910 Lorcom Lane, Arlington, Virginia 22207",
  },
  {
    alt: "I will be with you. Joshua 1:5",
    header: "I will be with you.",
    description: "- Joshua 1:5",
  },
];
